<template>
  <span
    v-if="plan"
    class="users-partner-plan-extra-info"
  >
    <span>
      <template v-if="plan.discountUnit === '$'">
        Discount: <b>{{ plan.discount | currency(2) }}</b>
      </template>
      <template v-else>
        Discount: <b>{{ plan.discount }}{{ plan.discountUnit }}</b>
      </template>
    </span>

    <span>
      |
    </span>

    <span>
      <template v-if="plan.commissionUnit === '$'">
        Commissions: <b>{{ plan.commission | currency(2) }}</b>
      </template>
      <template v-else>
        Commissions: <b>{{ plan.commission }}{{ plan.commissionUnit }}</b>
      </template>
    </span>
  </span>
</template>

<script>
export default {
  name: 'UsersPartnerPlanExtraInfo',
  props: {
    plan: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="stylus">
.users-partner-plan-extra-info
  font-size 15px
  display flex
  flex-direction row
  padding-left 10px
  margin-top -15px
  span
    color gray
    font-weight 400
    b
      font-weight 600
    + span
      margin-left 5px

.list-box-item.is-selected.is-focused
  .users-partner-form-select-plan-item
    .users-partner-plan-extra-info
      span
        color white

.users-partner-form-select-plan-item
  display block
  padding 5px 0
  &:hover
    .users-partner-plan-extra-info span
      color inherit
  .users-partner-plan-extra-info
    margin-top -5px
    padding-left 0
    b
      font-weight 400
</style>
